import { Inject, Injectable, OnDestroy } from '@angular/core';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { AuthService } from '../../auth/auth.service';
import { DefaultSocketService } from '../../common/websocket';

@Injectable({ providedIn: 'root' })
export class SocketService extends DefaultSocketService implements OnDestroy {
    constructor(
        private readonly _authService2: AuthService,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {
        super(_authService2);
    }

    ngOnDestroy(): void {
        this._destroy();
    }

    protected _websocketUrl(): string {
        return `${this._appConfig.API_ENDPOINTS.TEAMS_CALL ?? ''}/ws`;
    }
}
